<!--
 * @Author: p_fy
 * @Date: 2019-06-18 14:53:01
 * @LastEditors: pfy
 * @LastEditTime: 2019-09-29 15:57:13
 * @Description: 资质认证申诉页面，提交资质认证申诉信息。
 -->
<template>
  <div>
    <div class="main-wrap">
      <div class="menu-head title">
        <!-- <div class="head-color"/> -->
        <div>
          <span @click="apilist">{{ setCompanyShow() }}认证申诉</span>
        </div>
      </div>
      <div v-if="tjCard" class="submitClas">
        <el-card class="box-card">
          <span class="submitTile">您的申诉资料已提交</span>
          <el-row :gutter="20" class="elrow">
            <el-col :span="12">
              <span><a href="JavaScript:void(0);" class="sfSty" @click="renzhengCrad(true,false,false,false, false,false)">点击查看详情</a></span>
            </el-col>
            <el-col :span="12">
              <span><a href="JavaScript:void(0);" class="sfSty" @click="nolleProsequi()">取消申诉</a></span>
            </el-col>
          </el-row>
        </el-card>
      </div>

      <div v-if="SuccessCard" class="SuccessClas">
        <el-card class="box-card">
          <span>申诉成功了!<br>感谢您对平台的支持</span>
          <!-- <span style="width:100%;font-size: -webkit-xxx-large;font-family: cursive;margin-top:1rem;">{{ authentication.companyName }}物流欢迎您</span> -->
          <span><a href="JavaScript:void(0);" class="sfSty" @click="OpenRenzheng">现在去补充认证资料</a></span>
        </el-card>
      </div>

      <div v-if="failCard" style="" class="failClas">
        <el-card class="box-card">
          <span>您没有通过申诉!</span>
          <!-- <span style="width:100%;font-size: -webkit-xxx-large;font-family: cursive;">您填写的资料存在以下问题</span> -->
          <span>
            <ul>
              <li v-for="(item,index) in authentication.returnReasons" :key="index">{{ failShow(item,index) }}</li>
            </ul>
          </span>
          <span><a href="JavaScript:void(0);" class="sfSty" @click="renzhengCrad(true,true,false,false, false,false)">去修改</a></span>
        </el-card>
      </div>

      <div v-if="repeatCard" style="" class="repeatClas">
        <el-card class="box-card">
          <span>感谢您对平台的支持!<br>您所在的企业已经在平台注册</span>
          <span>客服电话 40081188888</span>
        </el-card>
      </div>

      <div v-if="renzhenCard" v-loading="loading">
        <div>
          <el-form
            ref="rulesForm"
            :rules="rules"
            :model="authentication"
            :label-position="'right'"
            label-width="135px"
            style="padding-left: 0rem;padding-right: 2rem;"
          >
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="认证类型">
                  <span style="color: #be2316;">{{ setCompanyShow() }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="账号">
                  <span>{{ userInfo.userName }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item v-input-filter label="公司名称" prop="companyName">
                  <el-input v-model="authentication.companyName" />
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="统一社会信用代码" prop="taxpayerNumber">
                  <el-input v-model="authentication.taxpayerNumber" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item v-input-filter label="联系人" prop="companyContact">
                  <el-input v-model="authentication.companyContact"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系电话" prop="contactTel">
                  <el-input v-model="authentication.contactTel" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item v-input-filter label="银行账户" prop="bankAccount">
                  <el-input v-model="authentication.bankAccount" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item v-input-filter label="开户行" prop="openingBank">
                  <el-input v-model="authentication.openingBank" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="公司地址" prop="companyAddress">
                  <el-cascader
                    v-model="authentication.companyAddress"
                    :options="area"
                    :filterable="true"
                    :props="{ expandTrigger: 'hover' ,
                              checkStrictly: true}"
                    style="width: 100%;"
                    class="companyAddress"
                    @expand-change="expandChange"
                  />
                </el-form-item>
                <!-- <el-form-item label="公司地址" prop="companyAddress">
                  <el-input v-model="authentication.companyAddress"  />
                </el-form-item> -->
              </el-col>
              <el-col :span="12">
                <el-form-item label="详细地址" class="detailsAddress" prop="detailsAddress">
                  <el-autocomplete
                    v-model="authentication.detailsAddress"
                    popper-class="my-autocomplete"
                    :fetch-suggestions="querySearch"
                    placeholder="请输入内容"
                    style="width: 100%;"
                    @select="handleSelect"
                  >
                    <template slot-scope="{ item }">
                      <div class="name">{{ item.value }}</div>
                      <!--<span class="addr">{{ item.address }}</span>-->
                    </template>
                  </el-autocomplete>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="营业执照" prop="licenseUrl">
                  <g-upload :limit="1" :method-name="authenticationFile" multiple :img-list.sync="authentication.licenseUrl" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <span v-if="submitCard" class="el-form-item__label" style="line-height: 30px;text-align: left;">上传有效营业执照,照片须为清晰、完整电子版图片,无遮挡、涂抹.支持55k-1M的jpg、bmp图片,可为扫描件或数码照</span>
                <div v-if="submitCard" class="el-form-item">
                  <span class="el-form-item__label">如图所示：</span>
                  <img src="@/assets/img/geren/yingye.png" style="width:45%;">
                </div>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="银行开户许可证" prop="permitUrl">
                  <g-upload :limit="1" :method-name="authenticationFile" multiple :img-list.sync="authentication.permitUrl" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <span v-if="submitCard" class="el-form-item__label" style="line-height: 30px;text-align: left;">上传有效银行开户许可证,照片须为清晰、完整电子版图片,无遮挡、涂抹.支持55k-1M的jpg、bmp图片,可为扫描件或数码照</span>
                <div v-if="submitCard" class="el-form-item">
                  <span class="el-form-item__label">如图所示：</span>
                  <img src="@/assets/img/geren/kaihuhang.jpg" style="width:45%;">
                </div>
              </el-col>
            </el-row>
            <el-row v-if="submitCard" :gutter="20">
              <el-col :span="12">
                <el-form-item label="">
                  <span style="color: #be2316;">注：</span>
                  <span>*均为必填项</span>
                </el-form-item>
              </el-col>
            </el-row>
            <div v-if="submitCard">
              <el-button
                class="el-button-ml"
                type="danger"
                round
                @click="modifiedAuthentication('rulesForm')"
              >提交</el-button>
            </div>
          </el-form>
          <!-- </el-card> -->
        </div>
      </div>
    </div>
  </div></template>
<script type="text/ecmascript-6">
import AMap from 'AMap' // 引入高德地图
import { mapGetters } from 'vuex'
// 引用数据
import { luhmFetchCheck } from '@/api/personal/user/qualifications-authen/authentication'
import { createInfo, getAuthInfo, editInfo, getArea, nolleProsequi } from '@/api/personal/user/appeal/appeal'
// 引用数据
import { Tyshyxdm } from '@/api/personal/user/qualifications-authen/authentication'

import { DatabaseUtil } from '@/utils/databaseUtils'
import validate, { isNormalStringValidator, isNormalString } from '@/utils/validate'
const dataBase = new DatabaseUtil()
export default {
  name: 'Appeal',
  components: {

  },
  computed: {
    ...mapGetters(['roles', 'userType', 'name', 'userInfo'])
  },
  data: function() {
    var taxpayerNumberRules = (rule, value, callback) => {
      if (!value) {
        this.companyShow = false
        return callback(new Error('请输入统一社会信用代码'))
      } else {
        var v = new Tyshyxdm().verify(value)
        if (!v) {
          return callback(new Error('不是有效的统一社会信用编码！'))
        } else {
          callback()
          return
        }
      }
    }

    // 银行账号校验方法
    var bankAccount = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请填写银行账号'))
      } else {
        luhmFetchCheck(value).then(bankResult => {
          this.authentication.openingBank = bankResult
          callback()
        }).catch(err => {
          console.log(err)
          return callback(new Error('卡号输入有误！请重新填写!'))
        })
      }
    }
    var licenseRules = (rule, value, callback) => {
      // callback()
      // return
      if (!value) {
        return callback(new Error('请上传营业执照'))
      } else {
        callback()
      }
    }
    var permitValidator = (rule, value, callback) => {
      // callback()
      // return
      if (!value) {
        return callback(new Error('请上传银行开户许可证'))
      } else {
        callback()
      }
    }
    return {
      imageUrl: '',
      companyTypeName: ['管理员', '货源企业', '运力企业', '仓储企业', '需求企业'],
      companyTypefile: ['admin', 'goodsFile', 'transportFile', 'cangchuFile', 'ccneedFile'],
      loading: false, // 预加载效果
      tjCard: false,
      repeatCard: false,
      failCard: false,
      SuccessCard: false,
      renzhenCard: false,
      submitCard: false,
      post_flag: false,
      //  隐藏数据 判断
      showTabXz: '1',
      showTable: '',
      userId: null,
      failContent: ['公司名称不合法', '统一社会信用代码不合法', '无法找到联系人', '开户行不明确', '营业执照不清晰', '相关证件不清晰'],
      authentication: {
        id: null,
        authId: null,
        companyType: '1', // 公司类型
        companyAddress: null, // 公司地址
        detailsAddress: null, // 详细地址
        companyContact: null, // 联系人
        companyName: null, // 公司名称
        contactTel: null, // 联系电话
        taxpayerNumber: null, // 纳税人识别号
        bankAccount: null, // 银行账号
        openingBank: null, // 开户行
        licenseUrl: '', // 营业执照
        permitUrl: '', // 银行开户许可证
        auditStatus: '1', // 1待审核 2拒绝 3首次认证 4重复认证
        returnReasons: [] // 退回原因
      }, // 定义弹框对象
      user: {
        name: '测试',
        userType: null
      },
      biaodanVisible: false,
      authenticationFile: '',
      area: null,
      yunliVisible: false,
      jiaoyiVisible: false,
      rules: {
        companyName: [{ required: true, message: '请输入公司名称', trigger: 'blur' }, { validator: isNormalStringValidator, trigger: 'blur' },{max:50,message:'不超过50个字符！'}],
        companyAddress: [{ required: true, message: '请选择公司地址', trigger: 'change' }], // 库房位置
        detailsAddress: [{ required: true, message: '请输入详细地址',trigger: 'blur' },{max:200,message:'不超过200个字符！'}], // 详细位置
        companyContact: [{ required: true, message: '请输入联系人', trigger: 'blur' }, { validator: isNormalStringValidator, trigger: 'blur' },{max:20,message:'不超过20个字符！'}],
        contactTel: [{ required: true, validator: this.$validate('phone') }],
        taxpayerNumber: [{ required: true, validator: taxpayerNumberRules, trigger: 'blur' }],
        bankAccount: [{ required: true, validator: bankAccount, trigger: 'blur' }, { validator: isNormalStringValidator, trigger: 'blur' },{max:20,message:'不超过20个字符！'}],
        openingBank: [{ required: true, message: '请输入开户行', trigger: 'blur' }, { validator: isNormalStringValidator, trigger: 'blur' },{max:50,message:'不超过50个字符！'}],
        licenseUrl: [{ required: true, validator: licenseRules, trigger: 'blur' }], // 营业执照（修改需审核）
        permitUrl: [{ required: true, validator: permitValidator, trigger: 'blur' }] // 银行开户许可证
      }
    }
  },
  watch: {
    '$route'(to, from) {
      if (to.name == 'Appeal') {
        this.apilist()
      }
    }
  },
  // 初始化加载 所有资格认证数据
  created() {
    (async() => {
      await this.getArea()
      this.apilist()
    })()
  },
  mounted() {
  },
  methods: {
    getLocalStorageUtil(name) {
      return new Promise((resolve, reject) => {
        if (dataBase.localStorageUtil.has(name)) {
          resolve(JSON.parse(dataBase.localStorageUtil.get(name)))
        } else {
          reject(name)
        }
      })
    },
    setLocalStorageUtil(name, result) {
      dataBase.localStorageUtil.set(name, JSON.stringify(result))
    },
    // 仓库位置点击事件处理
    expandChange() {
      setTimeout(function() {
        var alist = document.getElementsByClassName('el-radio__original')
        if (alist) {
          for (var idx = 0; idx < alist.length; idx++) {
            var mya = alist[idx]
            mya.style.cssText = 'width:160px;height:34px;z-index:1;top:-10px;cursor:inherit'
          }
        }
        console.log('执行了')
      }, 100)
    },
    // 详情位置回调
    handleSelect(item) {
      console.log(item)
    },
    // 地图定位查询
    querySearch(queryString, cb) {
      const addres = this.authentication.companyAddress
      if (addres == null || addres == '') {
        var isError = document.getElementsByClassName('companyAddress')
        this.authentication.detailsAddress = ''
        isError[0].querySelector('input').focus()
        cb([])
        this.$message({
          message: '请先选择公司位置!',
          offset: 100,
          type: 'warning'
        })
        // this.isErrorShow('请先选择公司位置!')
        return
      }
      if (queryString == null || queryString == '') {
        cb([])
        return
      }
      var results = []
      // const map = this.map
      AMap.service(['AMap.PlaceSearch'], () => {
      // 构造地点查询类
        const placeSearch = new AMap.PlaceSearch({
          pageSize: 5, // 单页显示结果条数
          pageIndex: 1, // 页码
          // city: '邹平', // 兴趣点城市
          city: addres[addres.length - 1],
          citylimit: true // 是否强制限制在设置的城市内搜索
          // map: map // 展现结果的地图实例
        // panel: 'panel', // 结果列表将在此容器中进行展示。
        // autoFitView: true // 是否自动调整地图视野使绘制的 Marker点都处于视口的可见范围
        })
        // 关键字查询
        placeSearch.search(queryString, (status, result) => {
          // alert(JSON.stringify(b))
          console.log(JSON.stringify(status))
          if (status == 'complete') {
            result.poiList.pois.forEach(element => {
              results.push({ 'title': element.name, 'value': element.address + element.name, 'address': element.address, 'location': element.location })
            })
            cb(results)
          } else {
            this.authentication.detailsAddress = ''
            cb(results)
            this.$message({
              message: '暂无数据!',
              offset: 100,
              type: 'warning'
            })
            // this.isErrorShow('暂无数据!')
            // cb(results)
          }
        })
      })
    },
    // 详情地址错误提示
    isErrorShow(errName) {
      setTimeout(function() {
        var isDetailsError = document.getElementsByClassName('detailsAddress')
        var detaError = isDetailsError[0].querySelector('.el-form-item__error')
        if (!detaError) {
          var autocomplete = isDetailsError[0].querySelector('.el-form-item__content')
          var btn = document.createElement('div')
          var att = document.createAttribute('class')
          att.value = 'el-form-item__error'
          btn.setAttributeNode(att)
          var t = document.createTextNode(errName)
          btn.appendChild(t)
          autocomplete.appendChild(btn)
          // var t=document.createTextNode("CLICK ME");
        } else {
          detaError.innerHTML = errName
        }
      }, 100)
    },
    // 地址字典
    getArea() {
      this.getLocalStorageUtil('area').then((data) => {
        this.area = data
      }).catch(() => {
        getArea()
          .then(data => {
            this.area = data.result
            this.setLocalStorageUtil('area', data.result)
          })
          .catch(error => {
            console.error(error)
          })
      })
    },
    // 撤销申诉
    nolleProsequi() {
      console.log('取消申诉')
      this.$confirm('您确定要取消申诉吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message({
          type: 'success',
          message: '已取消申诉!'
        })
        const params = JSON.parse(JSON.stringify(this.authentication))
        if (params.companyAddress != null && params.companyAddress.length > 0) {
          params.companyAddress = params.companyAddress.join('#')
        } else {
          params.companyAddress = null
        }
        if (params.returnReasons != null && params.returnReasons.length > 0) {
          params.returnReasons = params.returnReasons.join(',')
        } else {
          params.returnReasons = null
        }
        nolleProsequi(params).then((res) => {
          if (res) {
            this.OpenRenzheng()
          }
        }).catch(() => {})
      })
    },
    // 跳转资质认证页面
    OpenRenzheng() {
      this.$router.push({ name: 'QualificationsAuthen' })
    },
    failShow(item, index) {
      return `${index + 1}.${this.failContent[item - 1]}`
      // return item + '.' + this.failContent[item - 1]
    },
    // 公司类型转换
    setCompanyShow() {
      if (this.userType != null) {
        this.authenticationFile = this.companyTypefile[this.userType]
        return this.companyTypeName[this.userType]
      } else {
        return ''
      }
    },
    modifiedAuthentication(rulesForm) {
      // 正则验证数据 是否为空 根据el from的唯一标识
      this.$refs[rulesForm].validate(valid => {
        if (valid) {
          if (this.post_flag) {
            console.log(this.post_flag)
            return false
          }
          this.post_flag = true
          const params = JSON.parse(JSON.stringify(this.authentication))
          if (params.companyAddress != null && params.companyAddress.length > 0) {
            params.companyAddress = params.companyAddress.join('#')
          } else {
            params.companyAddress = null
          }
          if (params.returnReasons != null && params.returnReasons.length > 0) {
            params.returnReasons = params.returnReasons.join(',')
          } else {
            params.returnReasons = null
          }
          params.auditStatus = '1'
          params.userId = this.userId
          if (this.authentication.id != null) {
            editInfo(params).then((result) => {
              // 成功提示
              this.$message({
                showClose: true,
                message: '恭喜你，数据修改成功',
                type: 'success'
              })
              this.apilist()
              // this.renzhengCrad(false, false, true, false, false, false)
            }).catch((err) => {
              console.log(err)
              this.post_flag = false
            })
          } else {
            createInfo(params).then((result) => {
              // 成功提示
              this.$message({
                showClose: true,
                message: '恭喜你，数据保存成功',
                type: 'success'
              })
              this.apilist()
              // this.renzhengCrad(false, false, true, false, false, false)
            }).catch((err) => {
              console.log(err)
              this.post_flag = false
            })
          }
        } else {
          // 失败返回数据
          setTimeout(() => {
            var isError = document.getElementsByClassName('is-error')
            if (isError[0].querySelector('input').type == 'file') {
              isError[0].querySelector('input').style.display = 'block'
              isError[0].querySelector('input').focus()
              isError[0].querySelector('input').style.display = 'none'
            } else {
              isError[0].querySelector('input').focus()
            }
          }, 1)
          return false
        }
      })
    },
    apilist() {
      // this.renzhenCard = true
      this.loading = true
      getAuthInfo({ userId: this.userId }).then(res => {
        // 打印输出
        if (res.result != null) {
          if (res.result.auditStatus == '1') {
            this.renzhengCrad(false, false, true, false, false, false)
          } else if (res.result.auditStatus == '3') {
            this.renzhengCrad(false, false, false, true, false, false)
          } else if (res.result.auditStatus == '2') {
            this.renzhengCrad(false, false, false, false, true, false)
          } else if (res.result.auditStatus == '4') {
            this.renzhengCrad(false, false, false, false, false, true)
          } else {
            this.renzhengCrad(false, false, true, false, false, false)
          }

          this.post_flag = false
          this.authentication = res.result
          this.authentication.returnReasons = !res.result.returnReasons ? [] : res.result.returnReasons.split(',')
          this.authentication.companyAddress = !res.result.companyAddress ? [] : res.result.companyAddress.split('#')
          console.log(res.result)
        } else {
          this.renzhengCrad(true, true, false, false, false, false)
        }
        this.loading = false
        return
      }).catch((err) => {
        // this.renzhengCrad(false, false, true, false, false, false)
        console.log(err)
        this.loading = false
        // this.post_flag = false
        this.renzhengCrad(true, true, false, false, false, false)
      })
    },
    renzhengCrad(renzhen, submit, tj, success, fail, repeat) {
      this.renzhenCard = renzhen
      this.submitCard = submit
      this.tjCard = tj
      this.SuccessCard = success
      this.failCard = fail
      this.repeatCard = repeat
    },
    // 编辑事件
    editOpen(val) {
      // alert(JSON.stringify(val.authstatus))
      this.alterAuthentication.id = val.id
      this.authentication = val
      this.showTable = '1'
      this.showTabXz = '2'
    },
    // 新增方法
    showBiaodan(index) {
      // 正则验证数据
      this.showTable = '1'
      this.showTabXz = '2'
    },
    // 营业执照（修改需审核）
    licenseUrlSuccess(res, file) {
      this.authentication.licenseUrl = URL.createObjectURL(file.raw)
      console.log(this.authentication.licenseUrl)
    },
    // 银行开户许可证
    permitUrlSuccess(res, file) {
      this.authentication.permitUrl = URL.createObjectURL(file.raw)
      console.log(this.authentication.permitUrl)
    },
    // 营业执照（修改需审核）
    licenseUrlError(res, file) {
      this.authentication.licenseUrl = URL.createObjectURL(file.raw)
      console.log(this.authentication.licenseUrl)
    },
    // 银行开户许可证
    permitUrlError(res, file) {
      this.authentication.permitUrl = URL.createObjectURL(file.raw)
      console.log(this.authentication.permitUrl)
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isJPG && isLt2M
    }

    // 图片传位置
    // handleAvatarSuccess(res, file) {
    //   this.imageUrl = URL.createObjectURL(file.raw)
    // },
    // // 图片上传属性
    // beforeAvatarUpload(file) {
    //   const isJPG = file.type === 'image/jpeg'
    //   const isLt2M = file.size / 1024 / 1024 < 2
    //
    //   if (!isJPG) {
    //     this.$message.error('上传头像图片只能是 JPG 格式!')
    //   }
    //   if (!isLt2M) {
    //     this.$message.error('上传头像图片大小不能超过 1MB!')
    //   }
    //   return isJPG && isLt2M
    // }
  }
}
</script>
<style scoped lang='scss'>
  @import "@/styles/standardColor.scss";

  /deep/a{
    text-decoration: none;
  }

  .title{
    padding-top: 20px;
    span{
      color: #be2316;border-bottom: 1px solid;padding: 1rem;cursor: pointer;
    }
  }
  .submitClas{
    padding:3rem;
    text-align: center;
    .box-card {
      .submitTile{
        width:100%;
        font-size: -webkit-xxx-large;
        font-family: cursive;
      }
      .elrow{
        margin-top:3rem;
        span{
          width:50%;
        }
      }
    }
  }
  .SuccessClas{
    padding:3rem;
    text-align: center;
    .box-card span{
      &:nth-child(1){
        width:100%;
        font-size: -webkit-xxx-large;
        font-family: cursive;
      }
      &:nth-child(2){
        width:100%;
        margin-top:3rem;
      }
    }
  }
  .failClas{
    padding:3rem;
    text-align: center;
    .box-card span{
      &:nth-child(1){
        width:100%;
        font-size: -webkit-xxx-large;
        font-family: cursive;
      }
      &:nth-child(2){
        width:100%;
        font-size: x-large;
        font-family: cursive;
        margin-top: 1rem;
        text-align: left;
      }
      &:nth-child(3){
        width:100%;
        text-align: right;
      }
    }
  }
  .repeatClas{
    padding:3rem;
    text-align: center;
    .box-card span{
      &:nth-child(1){
        width:100%;
        font-size: -webkit-xxx-large;
        font-family: cursive;
      }
      &:nth-child(2){
        width:100%;
        font-size: x-large;
        font-family: cursive;
        margin-top: 1rem;
      }
    }
  }

   // 上传图片js
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  // 前面都是上传
  .intenal-box {
    width: 100%;
    height: 100%;
    padding: 50px 0px;
  }

    .upload-icon{
    margin: auto auto;
    width: 100%;
    line-height: 24px;
  }
  .upload-info-text{
    margin: auto auto;
    width: 100%;
    line-height: 50px;
  }

    /deep/ .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before  {
    content: '*';
    color: #be2316;
    font-size: 16px;
    margin-right: 4px;
  }
  input__inner {
    background-color: white;
    border-radius: 0px;
    border: 0;
    border-bottom: 1px solid gainsboro;
  }
  /deep/.el-input input{
    border-radius:0px;
  }
  /deep/.checkboxSty .el-input .el-input__inner , /deep/.el-textarea .el-textarea__inner{
    border-radius:0px;
  }
  /deep/.el-form-item {
    margin-bottom: 20px;
  }
  /deep/.checkboxSty{
    width:100%;
  }
  /deep/.sfSty{
    color:#409EFF
  }
  /deep/.sfSty:hover{
    color: #8c939d
  }
  /deep/.el-card .el-card__body{
    display: grid;
    padding: 4rem;
  }
  .el-button-ml{
    margin-left: 35%;
    width: 35%;
    height: 40px;
    margin-top: 50px;
    font-size: 18px;
    background-color: #BE2316;
    margin-bottom: 10%
  }
  .menu-head {
    display: flex;
    margin: 1rem;
    padding-bottom: 1rem;
    border-style: dashed;
    border-width: 0 0 1px 0;
    border-color: #f1f1f1;
    .head-color {
      width: 5px;
      height: 18px;
      background-color: #be2316;
      border-radius: 5px;
      margin-right: 1rem;
    }
    font-size: 18px;
    font-weight: bold;
  }
  .main-wrap{
    width: 100%;
    background-color: white;
    margin-top: -15px;
  }
</style>
